import {
  StrapiPostDTO,
  PostDTO,
} from "@lib/strapi/dtos/content-types/post.dto";

export class StrapiPostCategoryDTO {
  constructor() {}

  name: string;
  slug: string;
  description: string;
  sortIndex: number;
  posts: StrapiPostDTO[];
}

export class PostCategoryDTO {
  constructor() {}

  extraData: any = {};
  name: string;
  slug: string;
  description: string;
  sortIndex: number;
  posts: PostDTO[];
}
